<section>
  <h3 class="px-4 py-2 text-xs uppercase tracking-wider text-pmdf-base-primary mt-2">
    Ordens de Serviço
  </h3>

  @if (store.isLoading()) {
    <div class="flex items-center justify-center py-6">
      <mat-icon class="icon-lg text-pmdf-muted-30 animate-spin">sync</mat-icon>
    </div>
  } @else if (store.temErro()) {
    <div class="px-4 py-3 text-center">
      <mat-icon class="icon-md text-pmdf-danger mb-1">error_outline</mat-icon>
      <p class="text-xs text-pmdf-muted-55">Erro ao carregar OS</p>
      <button
        type="button"
        class="mt-2 text-xs text-pmdf-muted-30 underline"
        (click)="store.carregarOsDoTurno()"
      >Tentar novamente</button>
    </div>
  } @else if (store.ordensServico().length === 0) {
    <div class="px-4 py-6 text-center">
      <mat-icon class="icon-xl text-pmdf-muted-30 mb-2">assignment_turned_in</mat-icon>
      <p class="text-sm text-pmdf-muted-55">Nenhuma ordem de serviço para hoje</p>
    </div>
  } @else {
    <ul class="divide-y divide-pmdf-border">
      @for (os of store.ordensServico(); track os.id) {
        <li>
          <button
            type="button"
            class="w-full text-left px-4 py-3 hover:bg-pmdf-primary-alpha-08 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-pmdf-info"
            (click)="navegar(os.id)"
          >
            <div class="flex items-start justify-between gap-2">
              <p class="text-xs font-light text-pmdf-base-primary leading-tight line-clamp-2 flex-1">
                {{ os.titulo }}
              </p>
              <span class="shrink-0 rounded-pmdf-pill px-1.5 py-0.5 text-[9px] font-base {{ statusClasses(os.status) }}">
                {{ statusLabel(os.status) }}
              </span>
            </div>
            <div class="mt-1 flex items-center gap-1 text-xs text-pmdf-muted-55">
              <mat-icon class="icon-xs">schedule</mat-icon>
              <span>{{ formatarHorario(os.vigencia.inicio) }} – {{ formatarHorario(os.vigencia.fim) }}</span>
            </div>
            @if (os.episodios.length > 0) {
              <div class="mt-0.5 flex items-center gap-1 text-xs text-pmdf-muted-55">
                <mat-icon class="icon-xs">location_on</mat-icon>
                <span class="truncate">{{ os.episodios[0].cidade }}</span>
              </div>
            }
          </button>
        </li>
      }
    </ul>
  }
</section>
